<h2 class="mt-3">{{ sections.abstractTitle }}</h2>
<div *ngIf="sections.abstractBody" class="section-border revision-notices-page-section">
  <div [innerHTML]="sections.abstractBody | mdToHtml"></div>
</div>
